import React from 'react';
import Hero from '../elements/Hero.js';
import HeroBannerBlog from '../img/blog_banner.png';
import Title from '../elements/Title.js';
import Btn from '../elements/Btn.js';
import Footer from '../elements/Footer.js';
import PlayButton from '../img/PlayButton.png';
import Modal from '../elements/Modal';
import movie from '../video/movie.mp4';
import BannerRightImg from '../img/blogbanner_right.png';
import TrustedPartners from '../elements/TrustedPartners.js';
import BlogCard from '../elements/BlogCard.js';
import FreeQuote from '../elements/FreeQuote.js';
import Newsletter from '../elements/Newsletter.js';
import LearnArrow from '../img/down_arrow.png';
import blogimg1 from '../img/blogimg1.png';
import blogimg2 from '../img/blogimg2.png';
import blogimg3 from '../img/blogimg3.png';
import blogimg4 from '../img/blogimg4.png';
import { useState } from 'react';

export default function Blog() {

  const blogData = [
    {
      postDate: "May 20, 2022",
      postTitle: "Top 10 Instant Pot Recipes to Try When Moving | Exquisite Moves",
      postImg: blogimg1,
    },
    {
      postDate: "May 13, 2022",
      postTitle: "How to clean up from Hoarding | Exquisite Moves",
      postImg: blogimg2,
    },
    {
      postDate: "May 11, 2022",
      postTitle: "Various Types of Franchise Businesses",
      postImg: blogimg3,
    },
    {
      postDate: "May 10, 2022",
      postTitle: "Dumpster Renting vs Junk Removal Service | Exquisite Moves",
      postImg: blogimg4,
    },
    {
      postDate: "May 20, 2022",
      postTitle: "Top 10 Instant Pot Recipes to Try When Moving | Exquisite Moves",
      postImg: blogimg1,
    },
    {
      postDate: "May 13, 2022",
      postTitle: "How to clean up from Hoarding | Exquisite Moves",
      postImg: blogimg2,
    },
    {
      postDate: "May 11, 2022",
      postTitle: "Various Types of Franchise Businesses",
      postImg: blogimg3,
    },
    {
      postDate: "May 10, 2022",
      postTitle: "Dumpster Renting vs Junk Removal Service | Exquisite Moves",
      postImg: blogimg4,
    },
    {
      postDate: "May 11, 2022",
      postTitle: "Various Types of Franchise Businesses",
      postImg: blogimg3,
    },
    {
      postDate: "May 10, 2022",
      postTitle: "Dumpster Renting vs Junk Removal Service | Exquisite Moves",
      postImg: blogimg4,
    }
  ];

  const datalenght = blogData.length;
  const initialLimit = 4;
  const [last, setLast] = useState(initialLimit);
  const [list, setList] = useState(blogData.slice(0, initialLimit));
  const [nomore, setNomore] = useState(true);
  const loadmore = () => {
    const loaded = blogData.slice(last, last + 3);
    const newData = list.concat(loaded)
    setList(newData);
    if (last >= datalenght) {
      setNomore(false);
    } else {
      setLast(last + 3);
    }
  }
  return <>
    <Hero bg={HeroBannerBlog} clsName="blogbanner_sec" >
      <div className='pt-3 pt-sm-4 pt-lg-5 bannerTri' >
        <div className='row align-items-end' >
          <div className='col-lg-6 pb-3 pb-lg-5 mt-3' >
            <div className='banner_content py-0 pt-4' >
              <Modal modalclass="videoPopup" btnclass="bg-transparent border-0 d-table mb-5 " btntext={<>
                <div className='playBtn cursor-pointer'>
                  <img src={PlayButton} className="img-fluid" alt="image" />
                </div></>} >
                <video controls>
                  <source src={movie} type="video/mp4" />
                  <source src={movie} type="video/ogg" />
                </video>
              </Modal>
              <Title mainClass="text-start"
                titleclass="lg text-white mb-2 text-center text-lg-start"
                desclass=" text-center text-lg-start mt-3 mb-2"
                title={<>Stress-Free Moving <span>& <br /> Junk Removal, We Move People Forward!</span> </>}
                des="ExquisiteMoves is the nation’s leading full-service moving company, offering customers comprehensive home and business relocation, packing and unpacking, and junk removal services."
              />
              <Btn class="mb-0 mb-lg-4 mt-5 d-none d-md-table"
                arrow={true}
                wave={true}
                href="#"
              >Read Our Blog</Btn>
            </div>
          </div>
          <div className='col-lg-6 ps-lg-5' >
            <div className='blogbanner_right'>
              <img src={BannerRightImg} alt="img" />
            </div>
          </div>
        </div>
      </div>
    </Hero>
    <TrustedPartners />
    <div className='blog_sec py-3 py-sm-5' style={{ backgroundColor: '#FFFCF7' }}>
      <div className='container'>
        <Title mainClass="mb-3"
          subheading="blog & article"
          subclass="border-none text-center text-uppercase"
          titleclass="md heading text-dark text-center  mb-3 mt-0 mt-lg-3"
          desclass="mb-0 text-center w-50 m-auto d-table"
          title={<>Exquisite Moves Junk & Moving Blog</>}
          des="Learn from the professionals and stay up-to-date with everything College HUNKS. From tips, tricks, and guides to news and announcements, check out the College HUNKS blog for the latest from our team."
        />
        <div className='blog_list'>
          <div className='row' >
            {list && list.map((item, index) => {
              return <>
                <div key={index} className={`mb-4 ${index == 0 ? "col-md-12 fullBlog" 
                : "col-xl-4 col-lg-6"}`} >
                  <BlogCard item={item}  />
                </div>
              </>
            })}
          </div>
          {nomore ? <>
            <div className='blog_more mt-3 text-center'>
              <button onClick={loadmore} className="btn bg-none">Read More Blogs & Article <br /> <img src={LearnArrow} alt="arrow" /></button>
            </div>
          </> : <h2 className='nomore' >No More Blogs Found</h2>}
        </div>
      </div>
    </div>
    <FreeQuote />
    <Newsletter />
    <Footer />
  </>
}
